import { useCatalog } from "../context/CatalogContext";
import { SUPPORT_EMAIL, WEBSITE_URL } from "../lib/brand";
import { Link } from "react-router-dom";

export default function Footer() {
  const { categories } = useCatalog();
  return (
    <footer className="mt-16 bg-charcoal text-off-white">
      <div className="container-x py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-9 h-9 bg-terracotta text-off-white grid place-items-center font-heading font-bold text-lg">T</span>
            <div className="font-heading font-bold text-xl">TerraZoon</div>
          </div>
          <p className="text-sm text-off-white/70 max-w-xs">
            India&apos;s marketplace for construction materials & home decor — sourced from trusted sellers.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-terracotta font-semibold mb-3">Shop</div>
          <ul className="space-y-2 text-sm text-off-white/80">
            {categories.map((c) => <li key={c.slug}><Link data-testid={`footer-category-${c.slug}`} to={`/category/${c.slug}`} className="hover:text-terracotta">{c.name}</Link></li>)}
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-terracotta font-semibold mb-3">Sellers</div>
          <ul className="space-y-2 text-sm text-off-white/80">
            <li><Link to="/seller/signup" className="hover:text-terracotta">Become a Seller</Link></li>
            <li><Link to="/seller/login" className="hover:text-terracotta">Seller Login</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-terracotta font-semibold mb-3">Support</div>
          <ul className="space-y-2 text-sm text-off-white/80">
            <li><a data-testid="footer-support-email" href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-terracotta break-all">{SUPPORT_EMAIL}</a></li>
            <li><Link data-testid="footer-about" to="/about" className="hover:text-terracotta">About TerraZoon</Link></li>
            <li><Link data-testid="footer-terms" to="/terms" className="hover:text-terracotta">Terms & Conditions</Link></li>
            <li><Link data-testid="footer-privacy" to="/privacy" className="hover:text-terracotta">Privacy Policy</Link></li>
            <li><Link data-testid="footer-help" to="/help" className="hover:text-terracotta">Help Center</Link></li>
            <li><Link data-testid="footer-contact" to="/contact" className="hover:text-terracotta">Contact Us</Link></li>
            <li><Link data-testid="footer-returns" to="/returns" className="hover:text-terracotta">Returns & Refunds</Link></li>
            <li><Link data-testid="footer-admin-login" to="/admin/login" className="inline-block mt-2 text-xs text-off-white/80 underline underline-offset-4 hover:text-terracotta transition-colors">Admin Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-off-white/10">
        <div className="container-x py-4 text-xs text-off-white/60 flex flex-col md:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} TerraZoon. All rights reserved.</span>
          <a data-testid="footer-website" href={WEBSITE_URL} className="hover:text-terracotta">terrazoon.com · Delivering across Lucknow</a>
        </div>
      </div>
    </footer>
  );
}
